import React from 'react';
import { Alert, Form, Row, Col } from 'react-bootstrap';
import { IDpo } from '../index';
import { DEPARTAMENTOS } from '../../../constants/departamentos';
import { useT } from '../../../i18n';

interface DpoTabProps {
  dpo: IDpo;
  setDpo: React.Dispatch<React.SetStateAction<IDpo>>;
}

const formatPhone = (value: string): string => {
  const digits = value.replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 10) {
    return digits.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d{1,4})$/, '$1-$2');
  }
  return digits.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d{1,4})$/, '$1-$2');
};

const isValidEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const DpoTab: React.FC<DpoTabProps> = ({ dpo, setDpo }) => {
  const t = useT();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    if (name === 'telefone') {
      setDpo(prev => ({ ...prev, telefone: formatPhone(value) }));
    } else {
      setDpo(prev => ({ ...prev, [name]: value }));
    }
  };

  const emailInvalid = !!dpo.email && !isValidEmail(dpo.email);

  return (
    <div>
      <Alert variant="info" className="mb-4">
        <strong>{t('companyRegistration.dpo.alertTitle')}</strong><br />
        {t('companyRegistration.dpo.p1')}<strong>{t('companyRegistration.dpo.perfilAdministrador')}</strong>
        {t('companyRegistration.dpo.p2')}<strong>{t('companyRegistration.dpo.senhaTemporaria')}</strong>
        {t('companyRegistration.dpo.p3')}
      </Alert>

      <Form>
        <Row className="g-3">
          <Col md={6}>
            <Form.Group controlId="dpoNome">
              <Form.Label>{t('companyRegistration.dpo.nome')}</Form.Label>
              <Form.Control
                type="text"
                name="nome"
                value={dpo.nome}
                onChange={handleChange}
                placeholder={t('companyRegistration.dpo.nomePlaceholder')}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="dpoEmail">
              <Form.Label>{t('companyRegistration.dpo.email')}</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={dpo.email}
                onChange={handleChange}
                placeholder={t('companyRegistration.dpo.emailPlaceholder')}
                isInvalid={emailInvalid}
              />
              <Form.Control.Feedback type="invalid">{t('companyRegistration.dpo.emailInvalid')}</Form.Control.Feedback>
              <Form.Text className="text-muted">
                {t('companyRegistration.dpo.emailHelp')}
              </Form.Text>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="dpoTelefone">
              <Form.Label>{t('companyRegistration.dpo.telefone')}</Form.Label>
              <Form.Control
                type="tel"
                name="telefone"
                value={dpo.telefone}
                onChange={handleChange}
                placeholder={t('companyRegistration.dpo.telefonePlaceholder')}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="dpoDepartamento">
              <Form.Label>{t('companyRegistration.dpo.departamento')}</Form.Label>
              <Form.Select name="departamento" value={dpo.departamento} onChange={handleChange}>
                <option value="">{t('companyRegistration.dpo.selecione')}</option>
                {DEPARTAMENTOS.map(d => (
                  <option key={d} value={d}>{t(`departamento.${d}`)}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default DpoTab;
